var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollboxWrapper",
      staticClass: "faq-detail-box",
      class: {
        "box-overflow-hidden": _vm.callQuitWarning || _vm.callCommentInput
      }
    },
    [
      _vm.ajaxDone
        ? _c(
            "div",
            { ref: "scrollBox", staticClass: "faq-detail-wrapper" },
            [
              _c("div", { staticClass: "faq-detail" }, [
                _c("div", { staticClass: "faq-head" }, [
                  _c("span", { staticClass: "f-type" }, [_vm._v("常见问题")]),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "f-title",
                    domProps: { textContent: _vm._s(_vm.faqInfo.Question) }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "faq-content padding-sets" }, [
                  _c("div", { staticClass: "f-author flexBox" }, [
                    _c("img", {
                      staticClass: "avator",
                      attrs: { src: "" + _vm.faqInfo.HeadPic },
                      on: { error: _vm.$imgErr }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "flexItem" }, [
                      _c("p", {
                        staticClass: "f-author-name",
                        domProps: {
                          textContent: _vm._s(
                            _vm.faqInfo.OwnerEngName || _vm.faqInfo.OwnerName
                              ? _vm.faqInfo.OwnerEngName +
                                  " " +
                                  _vm.faqInfo.OwnerName
                              : "未知用户"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "f-update-last" }, [
                        _vm._v(
                          "更新于" +
                            _vm._s(_vm._f("timeAgo")(_vm.faqInfo.UpdatedOn))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      { staticClass: "f-enterprise-wechat" },
                      [
                        _c("img", {
                          staticClass: "tel",
                          attrs: { src: "/static/images/call-qywx.png" },
                          on: {
                            click: function($event) {
                              return _vm.actionEnterpriseChat(
                                _vm.faqInfo.Question,
                                _vm.faqInfo.OwnerEngName +
                                  " " +
                                  _vm.faqInfo.OwnerName,
                                _vm.faqInfo.ChatList
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "opacity-fade" } }, [
                          _vm.tooltipShow
                            ? _c(
                                "div",
                                {
                                  staticClass: "tooltip-wrap",
                                  on: { click: _vm.setTooltipRead }
                                },
                                [
                                  _c("span", { staticClass: "tooltip" }, [
                                    _vm._v("我是知识负责人，可以找我私聊"),
                                    _c("i", { staticClass: "k-close" }, [
                                      _vm._v("✕")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bottom-trangle" })
                                ]
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    ref: "fMaintain",
                    staticClass: "f-maintain",
                    class: [
                      _vm.$style["f-maintain"],
                      ((_obj = {}),
                      (_obj[_vm.$style["f-maintain-font-reset"]] =
                        _vm.resetClass),
                      _obj)
                    ],
                    domProps: { innerHTML: _vm._s(_vm.faqInfo.UnCopyContent) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.faqInfo.KnowLedgeName,
                          expression: "faqInfo.KnowLedgeName"
                        }
                      ],
                      staticClass: "f-belongTo"
                    },
                    [
                      _c("span", [_vm._v("归属知识：")]),
                      _c("span", {
                        staticClass: "f-knowledge",
                        domProps: {
                          textContent: _vm._s(_vm.faqInfo.KnowLedgeName)
                        },
                        on: {
                          click: function($event) {
                            return _vm.viewKnowledge(_vm.faqInfo.ParentKBInfoId)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "f-view-count" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("validCount")(_vm.faqInfo.TotalViewCount)
                        ) + "人浏览"
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.faqInfo.CopyContent
                ? _c("div", { staticClass: "faq-copyable-text padding-sets" }, [
                    _c("div", { staticClass: "faq-copyable-text-head" }, [
                      _c("span", { staticClass: "faq-copyable-text-tit" }, [
                        _vm._v("对外话术")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "clipboard",
                              rawName: "v-clipboard",
                              value: _vm.faqInfo.CopyContent,
                              expression: "faqInfo.CopyContent"
                            }
                          ],
                          staticClass: "faq-copyable-text-btn",
                          on: {
                            success: function($event) {
                              return _vm.copyText("success")
                            },
                            error: function($event) {
                              return _vm.copyText("failure")
                            }
                          }
                        },
                        [_vm._v("一键复制")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("article", {
                      ref: "faqCopyText",
                      staticClass: "faq-copyable-text-body",
                      class:
                        ((_obj$1 = {}),
                        (_obj$1[_vm.$style["faq-copyable-font-reset"]] =
                          _vm.resetClass),
                        _obj$1),
                      attrs: { id: "faq-copyable-text-body" },
                      domProps: {
                        innerHTML: _vm._s(_vm.faqInfo.DisCopyContent)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.InterestList.length
                ? _c(
                    "div",
                    { staticClass: "faq-recommend padding-sets" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "recommend-lists recommend-interest-lists"
                        },
                        _vm._l(_vm.InterestList, function(faq) {
                          return _c("section", {
                            staticClass: "recommend-list",
                            domProps: { textContent: _vm._s(faq.Title) },
                            on: {
                              click: function($event) {
                                return _vm.viewFaq(faq)
                              }
                            }
                          })
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.FIPageIndex < _vm.FIPageCount && _vm.prevAjaxEnd
                        ? _c(
                            "div",
                            {
                              staticClass: "recommend-load",
                              on: {
                                click: function($event) {
                                  return _vm.loadMore()
                                }
                              }
                            },
                            [_vm._v("查看更多")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.callRelatedFaqLoading ? _c("loading-more") : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "leave-divider" },
                [
                  _c("leave-list", {
                    attrs: {
                      commentListTitle: _vm.commentListTitle,
                      commentsTotalCount: _vm.commentsTotalCount,
                      commentsForPageCount: _vm.commentsForPageCount,
                      commentsList: _vm.commentsList,
                      checkMoreComment: _vm.checkMoreComment
                    },
                    on: {
                      checkMoreCommentClick: _vm.checkMoreCommentClick,
                      deleteComment: _vm.deleteComment,
                      initCommentList: _vm.initCommentList,
                      refreshCommentList: _vm.refreshCommentList
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.callQuitWarning
                ? _c("quit-message", {
                    attrs: {
                      messageTitle: _vm.messageTitle,
                      messageText: _vm.messageText,
                      queryBtn: _vm.queryBtn
                    },
                    on: {
                      closeQuitWarning: _vm.closeQuitWarning,
                      eventContinue: _vm.eventContinue
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("water-mark", { ref: "watermark" }),
              _vm._v(" "),
              _vm.callUnauthorize
                ? _c("unauthorize", {
                    attrs: { unauthorizeType: _vm.unauthorizeType }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("releave-recover", { attrs: { knowledgeInfo: _vm.faqInfo } })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "recommend-tabs flexBox" }, [
      _c("span", { staticClass: "recommend-tab" }, [_vm._v("相关常见问题")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-014c22dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-014c22dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/faqDetail.vue
// module id = Onse
// module chunks = 2